import { fetchData, PaginationParameters, PaginationResponse } from "@request";
import { getQueryParams } from "@request/helpers";

export type MerchantOrderPayoutRequest = PaginationParameters<{
  status?: string;
  min_sum?: number;
  max_sum?: number;
  order?: string;
  date_start?: number;
  date_end?: number;
  bank?: string;
  sort_dir?: string;
  method?: string;
  free?: boolean;
  cache_id?: string;
}>;

export type MerchantOrderPayout = {
  bank: string;
  closed_time: string;
  closed_time_unix: number;
  commission: number;
  created_at: string;
  created_at_unix: number;
  ern_usdt: number;
  exchange_rate: number;
  id: string;
  invid: string;
  merchant_spend_rub: number;
  merchant_spend_usdt: number;
  method: string;
  requisite: string;
  status: string;
  sum: number;
  sum_usdt: number;
};

export type OrderPayoutResponse = PaginationResponse<{
  pay_out_orders: MerchantOrderPayout[];
}>;

export const getMerchantPayoutOrdersApi = async (
  data: MerchantOrderPayoutRequest
) => {
  try {
    const queryParams = getQueryParams(data);

    const response = await fetchData<OrderPayoutResponse>({
      url: `api/v1/merchants/orders/pay-out?${queryParams}`,
    });

    return response;
  } catch (error) {
    console.error("getMerchantPayoutOrdersApi failed:", error);
    throw error;
  }
};
